(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mamo-goods-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mamo-goods')) {
    customElements.define('mamo-goods', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.grid = this.querySelector('[data-grid]');
        if (!this.grid) return;
        this.category = 'all';
        this.search = this.querySelector('[data-search]');
        this.budget = this.querySelector('[data-budget]');
        this.sort = this.querySelector('[data-sort]');
        this.available = this.querySelector('input[data-available]');
        this.count = this.querySelector('[data-count]');
        this.refreshCards();
        this.querySelector('[data-tools]').hidden = false;
        this.search.addEventListener('input', () => this.apply());
        [this.budget, this.sort, this.available].filter(Boolean).forEach(el => el.addEventListener('change', () => this.apply()));
        this.addEventListener('click', event => {
          const category = event.target.closest('[data-category]');
          const reset = event.target.closest('[data-reset]');
          const next = event.target.closest('[data-next]');
          if (category && this.contains(category)) { this.category = category.dataset.category; this.apply(); }
          if (reset && this.contains(reset)) {
            this.category = 'all'; this.search.value = ''; this.available.checked = false;
            if (this.budget) this.budget.value = 'all';
            this.sort.value = 'recommended'; this.apply(); this.search.focus({ preventScroll: true });
          }
          if (next && this.contains(next)) { event.preventDefault(); this.loadMore(next); }
        });
        this.apply();
      }
      normalize(text) { return text.normalize('NFKC').toLowerCase().replace(/[ァ-ヶ]/g, s => String.fromCharCode(s.charCodeAt(0) - 96)); }
      refreshCards() {
        this.cards = [...this.grid.querySelectorAll('[data-card]')].map(el => ({ el, text: this.normalize(el.dataset.searchText || ''), categories: el.dataset.categories.split(' '), price: Number(el.dataset.price), available: el.dataset.available === 'true', created: Number(el.dataset.created), order: Number(el.dataset.order) }));
        const hasMore = Boolean(this.querySelector('[data-next]'));
        this.querySelectorAll('[data-category]').forEach(button => {
          const category = button.dataset.category;
          button.hidden = category !== 'all' && !hasMore && !this.cards.some(card => card.categories.includes(category));
          if (button.hidden && this.category === category) this.category = 'all';
        });
      }
      apply() {
        const words = this.normalize(this.search.value.trim()).split(/\s+/).filter(Boolean);
        const budget = this.budget && this.budget.value !== 'all' ? this.budget.value.split(':').map(Number) : null;
        const sort = this.sort.value;
        const cards = [...this.cards].sort((a, b) => {
          if (sort === 'price-asc') return a.price - b.price || a.order - b.order;
          if (sort === 'price-desc') return b.price - a.price || a.order - b.order;
          if (sort === 'newest') return b.created - a.created || a.order - b.order;
          if (sort === 'recommended') return Number(b.available) - Number(a.available) || a.order - b.order;
          return a.order - b.order;
        });
        const fragment = document.createDocumentFragment();
        let shown = 0;
        cards.forEach(card => {
          const priceMatches = !budget || ((budget[0] === 0 ? card.price >= 0 : card.price > budget[0]) && card.price <= budget[1]);
          const match = (this.category === 'all' || card.categories.includes(this.category)) && words.every(word => card.text.includes(word)) && priceMatches && (!this.available.checked || card.available);
          card.el.hidden = !match;
          if (match) shown++;
          fragment.append(card.el);
        });
        this.grid.append(fragment);
        const next = this.querySelector('[data-next]');
        this.count.textContent = shown + ' 商品を表示 / ' + this.cards.length + ' 商品' + (next ? '（読み込み済みの商品内）' : '');
        this.querySelector('[data-empty]').hidden = shown !== 0;
        this.querySelectorAll('[data-category]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === this.category)));
      }
      async loadMore(link) {
        if (this.loading) return;
        this.loading = true;
        link.setAttribute('aria-disabled', 'true');
        const originalLabel = link.textContent;
        link.textContent = '読み込み中…';
        const message = this.querySelector('[data-load-message]');
        try {
          const url = new URL(link.href, location.href);
          if (url.origin !== location.origin) throw new Error('Unexpected origin');
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Load failed');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const root = doc.getElementById(this.id);
          if (!root) throw new Error('Section missing');
          const incoming = [...root.querySelectorAll('[data-card]')];
          if (!incoming.length) throw new Error('Products missing');
          const ids = new Set(this.cards.map(card => card.el.dataset.id));
          incoming.forEach(card => { if (!ids.has(card.dataset.id)) this.grid.append(document.importNode(card, true)); });
          const next = root.querySelector('[data-next]');
          if (next) { link.href = next.getAttribute('href'); link.textContent = originalLabel; }
          else { link.remove(); }
          if (message) message.textContent = next ? '続きの商品を追加しました。' : 'すべての商品を読み込みました。';
          this.refreshCards(); this.apply();
          if (!next) { this.count.tabIndex = -1; this.count.focus({ preventScroll: true }); }
        } catch (error) {
          link.textContent = 'もう一度読み込む';
          if (message) message.textContent = '商品を読み込めませんでした。通信環境を確認して、もう一度お試しください。';
        } finally { this.loading = false; link.removeAttribute('aria-disabled'); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
